import { PageMain } from './src/PageMain.js';

window.customElements.define('page-main', PageMain);
